export class ChangePasswordModel {
    public oldPassword: string = '';
    public newPassword: string = '';
    public passwordConfirmation: string = '';
}
